export default __webpack_public_path__ + "static/media/d4.759d4e31.png";